/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-18 15:02:30
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import SnConfigApi, { SnConfigDOI } from './api/snConfigApi';
 import { Integer } from 'src/types/base';
 import { createNamespace } from 'src/util/bem';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumSex from 'src/enums/enumSex';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import EnumOperates from 'src/enums/enumOperates';
 import RegexCheck from 'src/util/regexCheck';
 import IconCustom from 'src/components/icon/iconCustom';
 import FrameContentBg from 'src/pages/layout/components/frameContentBg';
 import HexFileApi, { HexFileDOI } from '../hexFileTree/api/hexFileApi';
 import { CommonUtil } from 'src/util/commonUtil';

 export namespace FileOperateVOI {
    export interface PropsI {
        sn: string;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        sn: string;
    }
 }


 @Component
 class FileOperateModal extends Vue.Component<FileOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: String,
    })
    sn!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: FileOperateVOI.FormDataI = {
        sn: '',
    };

    data: any = [];

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async mounted() {
        await this.queryAll();
        await this.setTree();
    }

    async setTree() {
        let tree = JSON.parse(JSON.stringify(this.data));
        let { code, data } = await SnConfigApi.querySnByFile(this.sn);
        if (code === 0) {
            CommonUtil.treeForEach(tree, (i: any) => {
                if (!i.children || i.children.length === 0) {
                    let realMenu = data.find(sub => i.id === sub.file_id);
                    if (!realMenu) {
                        return;
                    }
                    i.checked = data.some(sub => i.id === sub.file_id);
                }
            });

            this.data = tree;
        }
    }

    async queryAll() {
        let { code, data } = await HexFileApi.searchCatalogueTree();
        if (code === 0) {
            this.data = JSON.parse(JSON.stringify(await this.matterTree(data)));
        }
    }

    async matterTree(data) {
        for (var i = 0; i < data.length; i++) {
          data[i]["children"] = data[i]["children_list"]
          data[i]["title"] = data[i]["name"]
          if (data[i]["children_list"] && data[i]["children_list"].length > 0) {
            this.matterTree(data[i]["children_list"])
          }
        }
        return data
    }

    async save() {
        let ids: number[] = [];
        CommonUtil.treeForEach(this.data, (i: any) => {
            debugger
            var aaaa = i;
            if ((!i.children || i.children.length === 0) && i.checked) {
                ids.push(i.id);
            }
        });
        this.loading = true;
        let { code } = await SnConfigApi.saveSnFile(this.sn, ids);
        if (code === 0) {
            Toast.success('保存成功');
        }
        this.loading = false;
    }
      
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={"文件权限修改"}
                width="1000"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
            <FrameContentBg showCorner={false} radius={true}>
                <div class={createNamespace('pa30')}>
                    <tree ref="tree"  data={this.data} show-checkbox check-directly />
                </div>
            </FrameContentBg>
            <div slot="footer">
                <Button type="primary" ghost on-click={this.close}>
                    取消
                </Button>
                <Button type="primary" on-click={this.save} loading={this.loading}>
                    保存
                </Button>
            </div>
            </Modal>
        );
    }
 }

 export default function alertFileOperateModal(sn: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<FileOperateVOI.PropsI>(FileOperateModal)({
            sn,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
 }